import { useEffect } from "react";
import { GetSettingsListAtom, SetSettingsListAtom } from "../../store/settingsAtom";
import { Link } from "react-router-dom";

import { useNavigate, useParams, useLocation } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import RestartAlt from "@mui/icons-material/RestartAlt";
import { settingsService } from "../../services/settingsService";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import { formatCustomDate } from "../../helpers/formatCustomDate";



const columns = [
  {
    title: 'ID',
    key: 'Ref_No',
    dataIndex: 'Ref_No',
  className: "text-sn",
  sorter: (a, b) => (a?.Ref_No ?? '') - (b?.Ref_No ?? '')
  },

  {
    title: 'Feature_Action_URL_Name',
    // key: 'id',
    dataIndex: 'Feature_Name',
  className: "text-primary font-bold",
  sorter: (a, b) => (a?.Feature_Name ?? '').localeCompare(b?.Feature_Name ?? '')

  },
    
  {
    title: "Status",
    dataIndex: "Feature_Status_Name",
    sorter: (a, b) => (a?.Feature_Status_Name ?? '').localeCompare(b?.Feature_Status_Name ?? '')

  },

  {
    title: "Start Date",
    dataIndex: "Start_Date",
    sorter: (a, b) => (a?.Start_Date ?? '').localeCompare(b?.Start_Date ?? ''),
    render: (record) => <span> {formatCustomDate(record)} </span>,
    

  },
  {
    title: "End Date",
    dataIndex: "End_Date",
    sorter: (a, b) => (a?.End_Date ?? '').localeCompare(b?.End_Date ?? ''),
    render: (record) => <span> {formatCustomDate(record)} </span>,


  },
  {
    title: "Slide Order",
    dataIndex: "Slide_Order",
    sorter: (a, b) => (a?.Slide_Order ?? '') - (b?.Slide_Order ?? '')


  },

];



function HomePageFeaturePage() {
  const getFeatureList = GetSettingsListAtom();
  const setFeatureList = SetSettingsListAtom();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  var url = pathname.split('/')
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];


  useEffect(()=> {
    if(!getFeatureList?.feature_info?.length){
      fetchDataFromServer();

    }

  },[]);



  const newFeatureSetup = () => {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`);
  }


  const fetchDataFromServer = () => {
    settingsService.getFeatureList().then(res => {
      if (res.data?.action_url_info?.length){
        setFeatureList(res.data);
      }
    });
  }

  function handleRowClick(sel) {
    const id = sel['Ref_No'];
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`);
}




  return (
    <>
      <div className=" b">
        <section className="">
          <div className="flex justify-between  w-full  "  >
            <Tooltip title="Reload">
              <RestartAlt
                className="cursor ml-2 mt-1"
                onClick={() => fetchDataFromServer()}
                color="primary"
                fontSize="large"
              />
            </Tooltip>
            <button onClick={() => newFeatureSetup()}
              style={{ backgroundColor: "#476EF8" }}
              className="  rounded text-white text-sm font-[Poppins] py-2  px-3"
            >
              Add New
            </button>
          </div>


<section className="mt-5" >

<GeneralCustomTable
                          tableHeadList={columns} 
                          tableDataList={getFeatureList.feature_info}
                          allowCheckBox={false} // show checkBox for each row
                          setSelectedRows={()=>console.log('') }
                          rowKey={(record) => record.Ref_No} // custom key
                          handleRowClick={handleRowClick} />
</section>
        </section>
      </div>

    </>

  );
}

export default HomePageFeaturePage;
